export const CurrencyFormatCheck = currencySymbol => {
    return currencySymbol && currencySymbol === '₹'
        ? 'en-IN'
        : currencySymbol === '$' ||
            currencySymbol === 'RM' ||
            currencySymbol === 'AED' ||
            currencySymbol === '€' ||
            currencySymbol === '₱'
            ? 'en-US'
            : 'en-IN';
};

export const CurrencyFormat = (value, currencySymbol) =>
    !value || value === ''
        ? ''
        : new Intl.NumberFormat(CurrencyFormatCheck(currencySymbol), {
            style: 'decimal',
            currency: 'INR'
        }).format(parseInt(value));

export const CurrencyFormatWithDecimal = (
    value,
    withRupeeSymbol,
    currencySymbol,
    symbolCheck
) =>
    isNaN(parseInt(value)) || value === ''
        ? '-'
        : `${withRupeeSymbol ? '₹' : symbolCheck ? currencySymbol : ''
        }${new Intl.NumberFormat(
            // Adding Currency Format based on Currency symbol
            CurrencyFormatCheck(currencySymbol),
            {
                style: 'decimal',
                currency: 'INR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        ).format(Number(value).toFixed(2))}`;

export const CurrencyFormatWithoutDecimal = (
    value,
    withRupeeSymbol,
    currencySymbol
) =>
    isNaN(parseInt(value)) || value === ''
        ? '-'
        : `${withRupeeSymbol ? '₹' : ''}${new Intl.NumberFormat(
            CurrencyFormatCheck(currencySymbol),
            {
                currency: 'INR'
            }
        ).format(Number(value).toFixed(2))}`;